module.exports = __webpack_public_path__ + "img/thnaks_for_subscribing_header.e122a53f.svg";